import { React, useState, useEffect, useCallback } from 'react';
import { useTranslation } from "react-i18next";
import "./index.scss";

import successTick from "../../../../assets/images/common/Success.gif";
import failed from "../../../../assets/images/common/failed.gif";

import InputBox from "../../../ui/InputBox";
import Button from "../../../ui/Button";
import DropDown from "../../../ui/DropDown";
import RadioButton from "../../../ui/RadioButton";

import { useSelector, useDispatch } from 'react-redux';
import { getOrganizationList, resetOrganizationListResponse, addDomain, resetAddDomainResponse } from '../../../../store/actions/organizationActions';

import { getloggedInUserType } from "../../../../utils/util";
import SkeletonLoader from "../../../ui/SkeletonLoader";

const AddDomainModal = ({closeAddDomain}) => {

    const organizationListResponse = useSelector((state) => state.organization?.organizationList);
    const addDomainResponse = useSelector((state) => state.organization?.addDomainResponse);
    const serverListResposne = useSelector((state) => state?.domain?.serverList)

    const dispatch = useDispatch();

    const { t } = useTranslation();

    const [domainName, setDomainName] = useState('');
    const [selectedOrganization, setSelectedOrganization] = useState("");
    const [organizationList, setOrganizationList] = useState([]);
    const [organizationSearch, setOrganizationSearch] = useState("");
    const [organizationSearchLoading, setorganizationSearchLoading] = useState(false);
    const [organizationCurrentPage, setOrganizationCurrentPage] = useState(1);
    const [organizationPageLoading, setOrganizationPageLoading] = useState(false);
    const [organizationTotalPage, setOrganizationTotalPage] = useState(0);
    const [organizationListLoading, setOrganizationListLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [addDomainSuccess,setAddDomainSuccess] = useState(false);
    const [serverlist, setServerList] = useState([]);
    const [domainType, setDomainType] = useState("");


    const handleSelectOrganization = (value) => {
        setSelectedOrganization(value)
    }

    // Input change handlers
    const handleDomainNameChange = (val) => {
        setDomainName(val);
    }

    const goBack = () => {
        setDomainName('')
        setAddDomainSuccess(false)
        setIsLoading(false)
        dispatch(resetAddDomainResponse())
        closeAddDomain()
    }

    const fetchOrganization = useCallback(()=>{
        setOrganizationList([])
        setOrganizationListLoading(true)
        const baseUrl = `&page=1&page_size=10`;
        const type = domainType ? `&organization_type=${domainType}`: "";
        const url = `${baseUrl}${type}`;
        dispatch(getOrganizationList(url));
    },[dispatch, domainType])

    const saveDomain = () => {
        let obj = {
            domain:domainName,
        }
        if(getloggedInUserType() === "customer") {
            obj.organization_id = selectedOrganization.id
            obj.domain_type = domainType
        }
        if(getloggedInUserType() === "internal") {            
            obj.scan_from = selectedOrganization.id
        }
        setIsLoading(true)
        dispatch(addDomain(obj))
    }

    useEffect(()=>{        
        const baseUrl = `&page=${organizationCurrentPage}&page_size=10`
        const queryParams = organizationSearch ? `&query=${organizationSearch}` : "";
        const type = domainType ? `&organization_type=${domainType}`: ""
        const url = `${baseUrl}${type}${queryParams}`
        dispatch(getOrganizationList(url));
    },[organizationSearch, dispatch, domainType, organizationCurrentPage])

    useEffect(()=>{
        if(domainType !== "") {
            fetchOrganization();
        }        
    },[domainType, fetchOrganization])

    useEffect(()=>{
        if(organizationListResponse != null) {
            let list = organizationListResponse?.results.map((data)=>{
                return {
                    id: data.organization_id,
                    name: data.name,
                    value: data.organization_id,
                    logo: data.logo,
                    label: data.name
                }
            })
            setOrganizationList((prevList) => {
                const uniqueList = [...prevList, ...list].reduce((acc, item) => {
                    if (!acc.some(existingItem => existingItem.id === item.id)) {
                        acc.push(item);
                    }
                    return acc;
                }, []);
                return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
            });
            setOrganizationListLoading(false)
            setorganizationSearchLoading(false)
            setOrganizationPageLoading(false)
            setOrganizationTotalPage(organizationListResponse?.meta?.total_pages)
            dispatch(resetOrganizationListResponse())
        }
    },[organizationListResponse, dispatch])

    useEffect(()=>{
        if(addDomainResponse != null) {
            setAddDomainSuccess(true)
        } else {
            setDomainName('')
            setAddDomainSuccess(false)
            setIsLoading(false)
        }
    },[addDomainResponse, addDomainSuccess])

    useEffect(()=>{
        if(serverListResposne !== null) {
            let list = serverListResposne?.servers?.map((data)=>{
                return {
                    id: data.value,
                    name: data.name,
                    value: data.value,
                    logo: data.name,
                    label: data.name
                }
            })
            setServerList(list) 
        }
    },[serverListResposne])

    return (
        <div className="add-organization-container">
            {!addDomainSuccess && <div className="modal-header mt-4">
                <h2>{t("domainPage.addDomainModal.addDomain")}</h2>
            </div>}

            {!addDomainSuccess && <>
                <div className="add-organization-step-one mt-3">
                    <div className="input-container mt-4">
                        <InputBox placeholder={'Enter Name of the Domain'}
                            inputType={'text'}
                            inputLabel={'What is the Name of your Domain?'}
                            inputChange={handleDomainNameChange}
                            inputValue={domainName}
                        />
                    </div>
                    {getloggedInUserType() === "internal" && <div className="input-container mt-4 organization-select-domainPage">
                        <label>Scan from which Server</label>
                        <DropDown
                            options={serverlist}
                            placeHolder='Please select Server'
                            onChange={(e) => handleSelectOrganization(e)}
                            isSearchable = {true}
                            dropDownType = {'addDomain'}
                        />
                    </div>}
                    {getloggedInUserType() === "customer" && 
                    <>
                        <div className="organization-type">
                            <p>Domain Type</p>
                            <div className="radio-btn-group d-flex mt-3">
                                <div className="domain-type d-flex align-items-center gap-1">
                                    <RadioButton radioId={'internal'} radioLabel={'Internal'} radioValue={'internal'} onChange={(value)=>{setDomainType(value)}}  isChecked={domainType === 'internal'}/>                                    
                                </div>
                                <div className="domain-type d-flex align-items-center gap-1">
                                    <RadioButton radioId={'portfolio'} radioLabel={'Portfolio'} radioValue={'portfolio'} onChange={(value)=>{setDomainType(value)}} isChecked={domainType === 'portfolio'}/>                                    
                                </div>
                                <div className="domain-type d-flex align-items-center gap-1">
                                    <RadioButton radioId={'thirdParty'} radioLabel={'Third Party'} radioValue={'third_party'} onChange={(value)=>{setDomainType(value)}} isChecked={domainType === 'third_party'}/>                                    
                                </div> 
                            </div>
                        </div>
                        <div className="input-container mt-4 organization-select-domainPage">
                            {
                                organizationListLoading ?
                                <SkeletonLoader type={"line"} count={1} currentPage={"addDomainPage"} />
                                :
                                <>
                                    <label>Which Organization to assign?</label>
                                    <DropDown
                                        options={organizationList}
                                        placeHolder='Please select Organization'
                                        onChange={(e) => handleSelectOrganization(e)}
                                        isSearchable = {true}
                                        dropDownType = {'addDomain'}
                                        searchType = {"server"}
                                        updateSearchValue={(data) => {
                                            setOrganizationList([])
                                            setorganizationSearchLoading(true)
                                            setOrganizationSearch(data)
                                            setOrganizationCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage)); 
                                        }}
                                        isSearchLoading={organizationSearchLoading}
                                        onScrollEnd = {()=>{
                                            if(!organizationPageLoading && (organizationCurrentPage === 1 || organizationTotalPage > organizationCurrentPage)) {
                                                setOrganizationPageLoading(true)
                                                setOrganizationCurrentPage((prevPage) => prevPage + 1)
                                            }
                                        }}
                                        pageLoading={organizationPageLoading}
                                    />
                                </>
                            }
                        </div>
                    </>
                    }                    
                </div>

                <div className="form-submit-btn-group mt-4">
                    <Button buttonText={"Cancel"} buttonType="secondary" buttonClicked={goBack}/>
                    {!isLoading && <Button buttonText={"Save"} buttonType="primary" buttonClicked={()=>{saveDomain()}} disableButton={getloggedInUserType() === "internal" ? domainName === "" || selectedOrganization === "" : domainName === "" || selectedOrganization === "" || domainType === ""}/>}
                    {isLoading && <Button buttonText={"Loading..."} buttonType="primary" disableButton={true}/>}
                </div>
            </>}
            

            {/* Display success message when addOrgStep is 4 */}
            {addDomainSuccess && (
                <div className="addOrg-success-container d-flex align-items-center flex-column">
                    {
                        addDomainResponse?.detail?.status === "success" &&
                        <>
                            <div className="mt-5">
                                <img src={successTick} alt="success" />
                            </div>
                            <h2 className="mb-4 mt-5">{t("domainPage.addDomainModal.domainCreated")}</h2>
                            <p>{t("organizationDetailsPage.addDomain.successMsg")}</p>
                            <div className="btn-container mt-5">
                                <Button buttonText={"Back to Main Page"} buttonType="primary" buttonClicked={goBack} />
                            </div>
                        </>
                    }
                    {
                        addDomainResponse?.status === "failed" && 
                            <>
                            <div className="mt-5">
                                <img src={failed} alt="failed" />
                            </div>
                            <h2 className="mb-4 mt-5">{addDomainResponse?.description}</h2>
                            <div className="btn-container mt-5">
                                <Button buttonText={"Back to Main Page"} buttonType="primary" buttonClicked={goBack} />
                            </div>
                        </>
                    }
                    
                </div>
            )}
        </div>
    )
}

export default AddDomainModal;
